<template>
  <div class="admin-dashboard-container">
    <header class="admin-dashboard-header">
      <div class="admin-header-content">
        <button class="admin-mobile-menu-toggle" @click="toggleMobileMenu" aria-label="Toggle menu">
          <i class="bi bi-list"></i>
        </button>
        <div class="admin-header-brand">
          <span class="admin-header-brand-icon" aria-hidden="true">ab</span>
          <span class="admin-header-brand-name">AnnaBooks</span>
        </div>
        <div class="admin-header-text">
          <h1 class="admin-header-title">AnnaBooks</h1>
          <span class="admin-header-subtitle">Client Manager Panel</span>
        </div>
      </div>
    </header>

    <div
      v-if="isMobileMenuOpen"
      class="admin-mobile-overlay"
      @click="closeMobileMenu"
    ></div>

    <div class="admin-layout">
      <ClientManagerSideMenu
        :activeTab="sidebarActiveTab"
        :managerUser="managerUser"
        :isMobileOpen="isMobileMenuOpen"
        @tab-change="handleSidebarTabChange"
        @logout="handleLogout"
        @close-mobile="closeMobileMenu"
      />

      <main class="admin-dashboard-main client-manager-main">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import '../../Admin/styles/AdminDashboard.css';
import ClientManagerSideMenu from '../components/ClientManagerSideMenu.vue';

export default {
  name: 'ClientManagerLayout',
  components: { ClientManagerSideMenu },
  provide() {
    return {
      setManagerUserDisplay: (user) => {
        if (user) this.managerUser = user;
      }
    };
  },
  data() {
    return {
      managerUser: null,
      isMobileMenuOpen: false
    };
  },
  computed: {
    sidebarActiveTab() {
      const n = this.$route.name;
      if (n && String(n).startsWith('ManagerCompany')) {
        return 'clients';
      }
      const tab = this.$route.query.tab;
      if (tab === 'clients') return 'clients';
      if (tab === 'settings-profile') return 'settings-profile';
      return 'dashboard';
    }
  },
  mounted() {
    this.checkAuth();
  },
  methods: {
    checkAuth() {
      const managerToken = localStorage.getItem('managerToken');
      const managerUserRaw = localStorage.getItem('managerUser');
      if (!managerToken || !managerUserRaw) {
        this.$router.push('/client-manager/login');
        return;
      }
      this.managerUser = JSON.parse(managerUserRaw);
    },
    handleSidebarTabChange(tab) {
      if (tab === 'dashboard') {
        this.$router.push({ name: 'ClientManagerDashboard', query: {} });
      } else if (tab === 'clients') {
        this.$router.push({ name: 'ClientManagerDashboard', query: { tab: 'clients' } });
      } else if (tab === 'settings-profile') {
        this.$router.push({ name: 'ClientManagerDashboard', query: { tab: 'settings-profile' } });
      }
      this.closeMobileMenu();
    },
    handleLogout() {
      localStorage.removeItem('managerToken');
      localStorage.removeItem('managerUser');
      localStorage.removeItem('managerIsLoggedIn');
      this.$router.push('/client-manager/login');
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    }
  }
};
</script>

<style>
/* Tighter content area than default admin-dashboard-main (1rem) for manager panel */
.admin-dashboard-main.client-manager-main {
  padding: 0.5rem 0.75rem 0.75rem;
}
@media (min-width: 769px) {
  .admin-dashboard-main.client-manager-main {
    padding: 0.5rem 1rem 1rem;
  }
}
</style>
